@if (mailOrderPharmacyNameFn | async; as pharmacy) {
  <section aria-labelledby="support_page_heading" class="main-container">
    <h4 id="support_page_heading" class="uppercase text-w-500 center">
      {{ multilingualService?.langMap?.TITLE_CUSTOMER_SUPPORT }}
    </h4>
    @if (customerSupportItems$ | async; as customerSupportItems) {
      <div class="custom-box padding-box customer-support-content">
        @for (item of customerSupportItems; track $index) {
          @if (!(item.hide$ | async)) {
            <section class="support">
              <div class="d-flex">
                <img [imageName]="item.imageUrl" alt="Customer-Support" width="120px" />
                <div class="content">
                  @if (multilingualService?.langMap) {
                    <h2>
                      {{
                        multilingualService.langMap[item.title]
                          | placeholderReplace: { mailOrderPharmacyName: pharmacy.pharmacyName }
                      }}:
                      <a href="tel:{{ item.details.supportNumber }}">
                        {{ item.details.supportNumber }}
                      </a>
                    </h2>
                  }
                  <div
                    [innerHTML]="
                      item.details.htmlContent
                        | placeholderReplace: { mailOrderPharmacyName: pharmacy.pharmacyName }
                        | sanitizeHtml
                    "
                  ></div>
                </div>
              </div>
            </section>
          }
        }
        @if (errorMsg) {
          <div class="error-mesg empty-box-height">
            <div>
              <img
                aria-hidden="true"
                imageName="something-went-wrong.svg"
                [alt]="errorMsg"
                width="100px"
              />
              <p class="title-10 text-w-700">{{ errorMsg }}</p>
            </div>
          </div>
        }
      </div>
    } @else {
      <div aria-busy="true" class="center loader-circle">
        <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
      </div>
    }
  </section>
}
